const permissionsES = {}

export default permissionsES
